<template>
  <Base :base-id="'lb-sort'">
    <template #body>
      <span class="sort-title">SORT BY</span>
      <ol class="sub-list">
        <li :class="{ selected: selectedMode === 1 }">
          <a @click.prevent="changeOM(1)">最新上架</a>
        </li>
        <li :class="{ selected: selectedMode === 5 }">
          <a @click.prevent="changeOM(5)">最高人氣</a>
        </li>
        <div class="d-sm-none w-100" />
        <li :class="{ selected: selectedMode === 4 }">
          <a @click.prevent="changeOM(4)">價格：從低到高</a>
        </li>
        <li :class="{ selected: selectedMode === 3 }">
          <a @click.prevent="changeOM(3)">價格：從高到低</a>
        </li>
      </ol>
      <span class="sort-title sort-brand-title">BRAND</span>
      <div class="sort-brand">
        <a
          v-for="brand in modalData.Brands"
          :key="brand.Code"
          class="item-brand"
          :class="toggleBrand(brand.Code)"
          @click.prevent="addBrand(brand.Code)"
        >
          {{ brand.Name }}
        </a>
      </div>
      <span
        v-if="category !== 'BEAUTY' && modalData.Sizes.length !== 0"
        class="sort-title sort-size-title"
      >
        SIZE
      </span>
      <div v-if="category !== 'BEAUTY' && modalData.Sizes.length !== 0" class="sort-size">
        <a
          v-for="size in modalData.Sizes"
          :key="size.Key"
          :class="toggleSize(size.Value)"
          class="item-size"
          @click.prevent="addSize(size.Value)"
        >
          {{ size.Key }}
        </a>
      </div>
    </template>
    <template #footer>
      <div class="sort-btn">
        <a class="btn btn-reset" href="#" @click.prevent="clearCondition">清除</a>
        <a class="btn btn-confirm" href="#" @click.prevent="goResult">確定</a>
      </div>
    </template>
  </Base>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { storeToRefs } from 'pinia';
import $ from 'jquery';

import useModalStore from '@global/stores/useModalStore';

import Base from '@global/components/common/modal/Base.vue';

const modalStore = useModalStore();
const { modalData } = storeToRefs(modalStore);

const category = $('.member-page-title').text();

const selectedMode = ref(1);
const searchLocation = window.location.search;

selectedMode.value = getOrderMode();

function getOrderMode() {
  const args = searchLocation.split('&');

  let ModeStr = '';

  for (let i = 0; i < args.length; i++) {
    if (args[i].indexOf('OM') !== -1) {
      ModeStr = args[i];
    }
  }

  let mode = null;

  if (window.location.pathname === '/recent' && ModeStr.length === 0) {
    mode = 1;
  } else if (window.location.pathname === '/hot' && ModeStr.length === 0) {
    mode = 5;
  } else if (window.location.pathname === '/favorite' && ModeStr.length === 0) {
    mode = null;
  } else if (ModeStr.length === 0) {
    mode = 1;
  } else {
    mode = parseInt(ModeStr.charAt(ModeStr.length - 1));
  }
  return mode;
}

const selectedSizes = ref([]);
const selectedBrands = ref([]);
function getInitArgs() {
  const initSize = getTargetArgValue('S=').split(',');
  if (initSize[0].length !== 0) selectedSizes.value = initSize;
  const initBrand = getTargetArgValue('B=').split(',');
  if (initBrand[0].length !== 0) selectedBrands.value = initBrand;
}
function getTargetArgValue(arg) {
  let targetArg = '';
  if (window.location.search.length !== 0 && window.location.search.indexOf(arg) !== -1) {
    const args = window.location.toString().split('?')[1].split('&');
    args.forEach((element) => {
      if (element.indexOf(arg) !== -1) {
        targetArg = element;
      }
    });
  }
  return targetArg.length !== 0
    ? targetArg.substring(targetArg.indexOf('=') + 1, targetArg.length)
    : '';
}

const selectedOM = ref(1);
function changeOM(num) {
  selectedOM.value = num;
  selectedMode.value = num;
}

function clearCondition() {
  selectedSizes.value = [];
  selectedBrands.value = [];
}

function addSize(size) {
  const index = selectedSizes.value.findIndex((e) => {
    return e === size.toString();
  });

  if (index >= 0) {
    selectedSizes.value.splice(index, 1);
  } else {
    selectedSizes.value.push(size.toString());
  }
}
function toggleSize(size) {
  const isSelected = selectedSizes.value.includes(size.toString());
  return {
    active: isSelected,
    '': !isSelected,
  };
}
function addBrand(brand) {
  const index = selectedBrands.value.findIndex((e) => {
    return e === brand.toString();
  });

  if (index >= 0) {
    selectedBrands.value.splice(index, 1);
  } else {
    selectedBrands.value.push(brand.toString());
  }
}
function toggleBrand(brand) {
  const isSelected = selectedBrands.value.includes(brand.toString());
  return {
    active: isSelected,
    '': !isSelected,
  };
}

function goResult() {
  if (selectedSizes.value.length !== 0 || selectedBrands.value.length !== 0) {
    window.location.href = `${window.location.pathname}?${getOMArg()}&${getBrandArg()}${
      getBrandArg().length !== 0 && getSizeArg().length !== 0 ? '&' : ''
    }${getSizeArg()}`;
  } else {
    window.location.href = `${window.location.pathname}?${getOMArg()}`;
  }
}
function getOMArg() {
  return `OM=${selectedMode.value}`;
}
function getSizeArg() {
  return selectedSizes.value.length !== 0 ? `S=${selectedSizes.value.toString()}` : '';
}
function getBrandArg() {
  return selectedBrands.value.length !== 0 ? `B=${selectedBrands.value.toString()}` : '';
}

onMounted(() => {
  getInitArgs();
});
</script>
